import { isPhaserDragActive } from '../phaser/ui/bridge/dragState.js';

const EVENTS = [
  'pointerdown',
  'pointerup',
  'mousedown',
  'mouseup',
  'touchstart',
  'touchend',
  'wheel',
  'contextmenu',
];

function block(event) {
  // While a Phaser card drag is in flight, let pointer events through so the
  // drag can terminate on the canvas/window. Stopping the drag-ending pointerup
  // here would strand the dragged card on the cursor (it overlaps the board).
  // With no drag active we block as normal so taps/right-clicks/zoom don't leak
  // to the board underneath. Outside-click dismissal still works because
  // useDismiss listens in the capture phase (this is bubble phase).
  if (isPhaserDragActive()) return;
  // An overlay rendered into another document (the pop-out event log window,
  // docs/game-board/log-popout.md) has no board underneath to protect, and the
  // browser's own right-click menu (paste into chat, copy a log line) belongs
  // there, so the barrier stands down.
  if (event.currentTarget?.ownerDocument !== document) return;
  event.stopPropagation();
  // Right-click default is suppressed page-wide by a document-level listener
  // in app/frontend/entrypoints/game.js. Because we stop propagation here, that
  // listener never fires for events inside an overlay — so suppress the
  // browser's native context menu locally too.
  if (event.type === 'contextmenu') {
    event.preventDefault();
  }
}

export const overlayBarrier = {
  mounted(el) {
    el.__overlayBarrier__ = block;
    EVENTS.forEach((name) => {
      el.addEventListener(name, block, { passive: false });
    });
  },
  unmounted(el) {
    const fn = el.__overlayBarrier__;
    if (!fn) return;
    EVENTS.forEach((name) => {
      el.removeEventListener(name, fn);
    });
    delete el.__overlayBarrier__;
  },
};

export const OVERLAY_BARRIER_EVENTS = EVENTS;
